export default __webpack_public_path__ + "static/media/Aceptación lineamientos 2026.09b95329.docx";